import type { SVGProps } from "react";

type IconChevronRightProps = SVGProps<SVGSVGElement> & {
  strokeWidth?: number | string;
};

/**
 * chevron-right
 * @category Arrows
 */
export default function IconChevronRight({ strokeWidth = 1.5, ...props }: IconChevronRightProps) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9 4L15.5858 10.5858C16.3668 11.3668 16.3668 12.6331 15.5858 13.4142L9 20'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
